export default "<div>\n  <div (click)=\"invokeDelete()\">\n    <mat-icon>delete</mat-icon>\n    <span>Delete</span>\n  </div>\n</div>\n";